const { createConstant } = require('../helpers')

// Check address, this might change
const service = 'case-service'

module.exports = {
  // For Admin Users
  GET_ADMIN_CONSULTATIONS_LIST: createConstant(service, 'GET_ADMIN_CONSULTATIONS_LIST'),
  GET_ADMIN_CONSULTATIONS_LIST_SUCCESS: createConstant(service, 'GET_ADMIN_CONSULTATIONS_LIST_SUCCESS'),
  GET_ADMIN_CONSULTATIONS_LIST_ERROR: createConstant(service, 'GET_ADMIN_CONSULTATIONS_LIST_ERROR'),
  GET_ADMIN_CONSULTATIONS_LIST_RESET: createConstant(service, 'GET_ADMIN_CONSULTATIONS_LIST_RESET'),

  // For Admin Users
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL: createConstant(service, 'SEND_ADMIN_CONSULTATIONS_CSV_EMAIL'),
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_SUCCESS: createConstant(service, 'SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_SUCCESS'),
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_ERROR: createConstant(service, 'SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_ERROR'),
  SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_RESET: createConstant(service, 'SEND_ADMIN_CONSULTATIONS_CSV_EMAIL_RESET'),

  // For Admin Users
  GET_ADMIN_CONSULTATION: createConstant(service, 'GET_ADMIN_CONSULTATION'),
  GET_ADMIN_CONSULTATION_SUCCESS: createConstant(service, 'GET_ADMIN_CONSULTATION_SUCCESS'),
  GET_ADMIN_CONSULTATION_ERROR: createConstant(service, 'GET_ADMIN_CONSULTATION_ERROR'),
  GET_ADMIN_CONSULTATION_RESET: createConstant(service, 'GET_ADMIN_CONSULTATION_RESET'),

  // For Admin Users
  CREATE_ADMIN_CONSULTATION: createConstant(service, 'CREATE_ADMIN_CONSULTATION'),
  CREATE_ADMIN_CONSULTATION_SUCCESS: createConstant(service, 'CREATE_ADMIN_CONSULTATION_SUCCESS'),
  CREATE_ADMIN_CONSULTATION_ERROR: createConstant(service, 'CREATE_ADMIN_CONSULTATION_ERROR'),
  CREATE_ADMIN_CONSULTATION_RESET: createConstant(service, 'CREATE_ADMIN_CONSULTATION_RESET'),

  // For Admin Users
  UPDATE_ADMIN_CONSULTATION: createConstant(service, 'UPDATE_ADMIN_CONSULTATION'),
  UPDATE_ADMIN_CONSULTATION_SUCCESS: createConstant(service, 'UPDATE_ADMIN_CONSULTATION_SUCCESS'),
  UPDATE_ADMIN_CONSULTATION_ERROR: createConstant(service, 'UPDATE_ADMIN_CONSULTATION_ERROR'),
  UPDATE_ADMIN_CONSULTATION_RESET: createConstant(service, 'UPDATE_ADMIN_CONSULTATION_RESET'),

  // For Admin Users
  DELETE_ADMIN_CONSULTATION: createConstant(service, 'DELETE_ADMIN_CONSULTATION'),
  DELETE_ADMIN_CONSULTATION_SUCCESS: createConstant(service, 'DELETE_ADMIN_CONSULTATION_SUCCESS'),
  DELETE_ADMIN_CONSULTATION_ERROR: createConstant(service, 'DELETE_ADMIN_CONSULTATION_ERROR'),
  DELETE_ADMIN_CONSULTATION_RESET: createConstant(service, 'DELETE_ADMIN_CONSULTATION_RESET'),

  // For Admin Users
  UPDATE_STATUS_ADMIN_CONSULTATION: createConstant(service, 'UPDATE_STATUS_ADMIN_CONSULTATION'),
  UPDATE_STATUS_ADMIN_CONSULTATION_SUCCESS: createConstant(service, 'UPDATE_STATUS_ADMIN_CONSULTATION_SUCCESS'),
  UPDATE_STATUS_ADMIN_CONSULTATION_ERROR: createConstant(service, 'UPDATE_STATUS_ADMIN_CONSULTATION_ERROR'),
  UPDATE_STATUS_ADMIN_CONSULTATION_RESET: createConstant(service, 'UPDATE_STATUS_ADMIN_CONSULTATION_RESET'),

  GET_CONSULTATIONS_LIST: createConstant(service, 'GET_CONSULTATIONS_LIST'),
  GET_CONSULTATIONS_LIST_SUCCESS: createConstant(service, 'GET_CONSULTATIONS_LIST_SUCCESS'),
  GET_CONSULTATIONS_LIST_ERROR: createConstant(service, 'GET_CONSULTATIONS_LIST_ERROR'),
  GET_CONSULTATIONS_LIST_RESET: createConstant(service, 'GET_CONSULTATIONS_LIST_RESET'),

  GET_AVAILABLE_CONSULTATIONS_LIST: createConstant(service, 'GET_AVAILABLE_CONSULTATIONS_LIST'),
  GET_AVAILABLE_CONSULTATIONS_LIST_SUCCESS: createConstant(service, 'GET_AVAILABLE_CONSULTATIONS_LIST_SUCCESS'),
  GET_AVAILABLE_CONSULTATIONS_LIST_ERROR: createConstant(service, 'GET_AVAILABLE_CONSULTATIONS_LIST_ERROR'),
  GET_AVAILABLE_CONSULTATIONS_LIST_RESET: createConstant(service, 'GET_AVAILABLE_CONSULTATIONS_LIST_RESET'),

  CREATE_CONSULTATION: createConstant(service, 'CREATE_CONSULTATION'),
  CREATE_CONSULTATION_SUCCESS: createConstant(service, 'CREATE_CONSULTATION_SUCCESS'),
  CREATE_CONSULTATION_ERROR: createConstant(service, 'CREATE_CONSULTATION_ERROR'),
  CREATE_CONSULTATION_RESET: createConstant(service, 'CREATE_CONSULTATION_RESET'),

  GET_CONSULTATION_HISTORY_LIST: createConstant(service, 'GET_CONSULTATION_HISTORY_LIST'),
  GET_CONSULTATION_HISTORY_LIST_SUCCESS: createConstant(service, 'GET_CONSULTATION_HISTORY_LIST_SUCCESS'),
  GET_CONSULTATION_HISTORY_LIST_ERROR: createConstant(service, 'GET_CONSULTATION_HISTORY_LIST_ERROR'),
  GET_CONSULTATION_HISTORY_LIST_RESET: createConstant(service, 'GET_CONSULTATION_HISTORY_LIST_RESET'),

  GET_CONSULTATION_HISTORY_DETAILS: createConstant(service, 'GET_CONSULTATION_HISTORY_DETAILS'),
  GET_CONSULTATION_HISTORY_SUCCESS: createConstant(service, 'GET_CONSULTATION_HISTORY_SUCCESS'),
  GET_CONSULTATION_HISTORY_ERROR: createConstant(service, 'GET_CONSULTATION_HISTORY_ERROR'),
  GET_CONSULTATION_HISTORY_RESET: createConstant(service, 'GET_CONSULTATION_HISTORY_RESET'),

  GET_DOCTOR_CONSULTATION_HISTORY_LIST: createConstant(service, 'GET_DOCTOR_CONSULTATION_HISTORY_LIST'),
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_SUCCESS: createConstant(service, 'GET_DOCTOR_CONSULTATION_HISTORY_LIST_SUCCESS'),
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_ERROR: createConstant(service, 'GET_DOCTOR_CONSULTATION_HISTORY_LIST_ERROR'),
  GET_DOCTOR_CONSULTATION_HISTORY_LIST_RESET: createConstant(service, 'GET_DOCTOR_CONSULTATION_HISTORY_LIST_RESET'),

  GET_DOCTOR_CONSULTATION_OVERVIEW: createConstant(service, 'GET_DOCTOR_CONSULTATION_OVERVIEW'),
  GET_DOCTOR_CONSULTATION_OVERVIEW_SUCCESS: createConstant(service, 'GET_DOCTOR_CONSULTATION_OVERVIEW_SUCCESS'),
  GET_DOCTOR_CONSULTATION_OVERVIEW_ERROR: createConstant(service, 'GET_DOCTOR_CONSULTATION_OVERVIEW_ERROR'),
  GET_DOCTOR_CONSULTATION_OVERVIEW_RESET: createConstant(service, 'GET_DOCTOR_CONSULTATION_OVERVIEW_RESET'),

  ASSIGN_DOC_TO_CONSULTATION: createConstant(service, 'ASSIGN_DOC_TO_CONSULTATION'),
  ASSIGN_DOC_TO_CONSULTATION_SUCCESS: createConstant(service, 'ASSIGN_DOC_TO_CONSULTATION_SUCCESS'),
  ASSIGN_DOC_TO_CONSULTATION_ERROR: createConstant(service, 'ASSIGN_DOC_TO_CONSULTATION_ERROR'),
  ASSIGN_DOC_TO_CONSULTATION_RESET: createConstant(service, 'ASSIGN_DOC_TO_CONSULTATION_RESET'),

  SET_CONSULTATION_PREFERENCE: createConstant(service, 'SET_CONSULTATION_PREFERENCE'),
  SET_CONSULTATION_PREFERENCE_SUCCESS: createConstant(service, 'SET_CONSULTATION_PREFERENCE_SUCCESS'),
  SET_CONSULTATION_PREFERENCE_ERROR: createConstant(service, 'SET_CONSULTATION_PREFERENCE_ERROR'),
  SET_CONSULTATION_PREFERENCE_RESET: createConstant(service, 'SET_CONSULTATION_PREFERENCE_RESET'),

  GET_PATIENT_RECORD: createConstant(service, 'GET_PATIENT_RECORD'),
  GET_PATIENT_RECORD_SUCCESS: createConstant(service, 'GET_PATIENT_RECORD_SUCCESS'),
  GET_PATIENT_RECORD_ERROR: createConstant(service, 'GET_PATIENT_RECORD_ERROR'),
  GET_PATIENT_RECORD_RESET: createConstant(service, 'GET_PATIENT_RECORD_RESET'),

  POST_DOCTOR_NOTES: createConstant(service, 'POST_DOCTOR_NOTES'),
  POST_DOCTOR_NOTES_SUCCESS: createConstant(service, 'POST_DOCTOR_NOTES_SUCCESS'),
  POST_DOCTOR_NOTES_ERROR: createConstant(service, 'POST_DOCTOR_NOTES_ERROR'),
  POST_DOCTOR_NOTES_RESET: createConstant(service, 'POST_DOCTOR_NOTES_RESET'),

  POST_DOCTOR_MC: createConstant(service, 'POST_DOCTOR_MC'),
  POST_DOCTOR_MC_SUCCESS: createConstant(service, 'POST_DOCTOR_MC_SUCCESS'),
  POST_DOCTOR_MC_ERROR: createConstant(service, 'POST_DOCTOR_MC_ERROR'),
  POST_DOCTOR_MC_RESET: createConstant(service, 'POST_DOCTOR_MC_RESET'),

  POST_DOCTOR_REFERRAL: createConstant(service, 'POST_DOCTOR_REFERRAL'),
  POST_DOCTOR_REFERRAL_SUCCESS: createConstant(service, 'POST_DOCTOR_REFERRAL_SUCCESS'),
  POST_DOCTOR_REFERRAL_ERROR: createConstant(service, 'POST_DOCTOR_REFERRAL_ERROR'),
  POST_DOCTOR_REFERRAL_RESET: createConstant(service, 'POST_DOCTOR_REFERRAL_RESET'),

  END_DOCTOR_CONSULTATION: createConstant(service, 'END_DOCTOR_CONSULTATION'),
  END_DOCTOR_CONSULTATION_SUCCESS: createConstant(service, 'END_DOCTOR_CONSULTATION_SUCCESS'),
  END_DOCTOR_CONSULTATION_ERROR: createConstant(service, 'END_DOCTOR_CONSULTATION_ERROR'),
  END_DOCTOR_CONSULTATION_RESET: createConstant(service, 'END_DOCTOR_CONSULTATION_RESET'),

  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR: createConstant(service, 'SEND_AUDIO_CALL_REQUEST_BY_DOCTOR'),
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_SUCCESS: createConstant(service, 'SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_SUCCESS'),
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_ERROR: createConstant(service, 'SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_ERROR'),
  SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_RESET: createConstant(service, 'SEND_AUDIO_CALL_REQUEST_BY_DOCTOR_RESET'),

  GET_DOCTOR_TWILIO_TOKEN: createConstant(service, 'GET_DOCTOR_TWILIO_TOKEN'),
  GET_DOCTOR_TWILIO_TOKEN_SUCCESS: createConstant(service, 'GET_DOCTOR_TWILIO_TOKEN_SUCCESS'),
  GET_DOCTOR_TWILIO_TOKEN_ERROR: createConstant(service, 'GET_DOCTOR_TWILIO_TOKEN_ERROR'),
  GET_DOCTOR_TWILIO_TOKEN_RESET: createConstant(service, 'GET_DOCTOR_TWILIO_TOKEN_RESET'),

  POST_DOCTOR_CONSULTATION_TIME_LAPSED: createConstant(service, 'POST_DOCTOR_CONSULTATION_TIME_LAPSED'),
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_SUCCESS: createConstant(service, 'POST_DOCTOR_CONSULTATION_TIME_LAPSED_SUCCESS'),
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_ERROR: createConstant(service, 'POST_DOCTOR_CONSULTATION_TIME_LAPSED_ERROR'),
  POST_DOCTOR_CONSULTATION_TIME_LAPSED_RESET: createConstant(service, 'POST_DOCTOR_CONSULTATION_TIME_LAPSED_RESET'),

  GET_MD_REFERRAL_NEW_LINK: createConstant(service, 'GET_MD_REFERRAL_NEW_LINK'),
  GET_MD_REFERRAL_NEW_LINK_SUCCESS: createConstant(service, 'GET_MD_REFERRAL_NEW_LINK_SUCCESS'),
  GET_MD_REFERRAL_NEW_LINK_ERROR: createConstant(service, 'GET_MD_REFERRAL_NEW_LINK_ERROR'),
  GET_MD_REFERRAL_NEW_LINK_RESET: createConstant(service, 'GET_MD_REFERRAL_NEW_LINK_RESET'),

  GET_MD_MC_NEW_LINK: createConstant(service, 'GET_MD_MC_NEW_LINK'),
  GET_MD_MC_NEW_LINK_SUCCESS: createConstant(service, 'GET_MD_MC_NEW_LINK_SUCCESS'),
  GET_MD_MC_NEW_LINK_ERROR: createConstant(service, 'GET_MD_MC_NEW_LINK_ERROR'),
  GET_MD_MC_NEW_LINK_RESET: createConstant(service, 'GET_MD_MC_NEW_LINK_RESET'),

  CHECK_PATIENT_CONSULTATION_STATUS: createConstant(service, 'CHECK_PATIENT_CONSULTATION_STATUS'),
  CHECK_PATIENT_CONSULTATION_STATUS_SUCCESS: createConstant(service, 'CHECK_PATIENT_CONSULTATION_STATUS_SUCCESS'),
  CHECK_PATIENT_CONSULTATION_STATUS_ERROR: createConstant(service, 'CHECK_PATIENT_CONSULTATION_STATUS_ERROR'),
  CHECK_PATIENT_CONSULTATION_STATUS_RESET: createConstant(service, 'CHECK_PATIENT_CONSULTATION_STATUS_RESET'),

  VERIFY_TRANSACTION_AMOUNT: createConstant(service, 'VERIFY_TRANSACTION_AMOUNT'),
  VERIFY_TRANSACTION_AMOUNT_SUCCESS: createConstant(service, 'VERIFY_TRANSACTION_AMOUNT_SUCCESS'),
  VERIFY_TRANSACTION_AMOUNT_ERROR: createConstant(service, 'VERIFY_TRANSACTION_AMOUNT_ERROR'),
  VERIFY_TRANSACTION_AMOUNT_RESET: createConstant(service, 'VERIFY_TRANSACTION_AMOUNT_RESET'),

  GET_PRESCRIPTION_ID: createConstant(service, 'GET_PRESCRIPTION_ID'),
  GET_PRESCRIPTION_ID_SUCCESS: createConstant(service, 'GET_PRESCRIPTION_ID_SUCCESS'),
  GET_PRESCRIPTION_ID_ERROR: createConstant(service, 'GET_PRESCRIPTION_ID_ERROR'),
  GET_PRESCRIPTION_ID_RESET: createConstant(service, 'GET_PRESCRIPTION_ID_RESET'),

  POST_REGENERATE_AGORA_TOKEN: createConstant(service, 'POST_REGENERATE_AGORA_TOKEN'),
  POST_REGENERATE_AGORA_TOKEN_SUCCESS: createConstant(service, 'POST_REGENERATE_AGORA_TOKEN_SUCCESS'),
  POST_REGENERATE_AGORA_TOKEN_ERROR: createConstant(service, 'POST_REGENERATE_AGORA_TOKEN_ERROR'),
  POST_REGENERATE_AGORA_TOKEN_RESET: createConstant(service, 'POST_REGENERATE_AGORA_TOKEN_RESET'),
}
